





















import { ProductType } from "@/models/products/product";
import { Vue, Component } from "vue-property-decorator";
import CustomizeUmbrella from "@/components/items/CustomizeUmbrella.vue";
import CustomizeBase from "@/components/items/CustomizeBase.vue";
import CustomizeChair from "@/components/items/CustomizeChair.vue";
import { ProductLineName } from "@/models/products/collection";
@Component({
  components: {
    CustomizeUmbrella,
    CustomizeBase,
    CustomizeChair
  }
})
export default class ItemCustomization extends Vue {
  protected productType = ProductType;
  protected product: ProductType | "" = "";
  protected handle: ProductLineName | "" = "";

  created(): void {
    this.checkQuery();
  }

  protected checkQuery(): void {
    const hasParams = this.$route.params && this.$route.params.product;
    const hasQuery = this.$route.query && this.$route.query.handle;
    if (!hasParams || !hasQuery) {
      const url = hasParams ? "/" + this.$route.params.product : "";
      this.$router.replace(`/collections${url}`);
    } else {
      this.product = this.$route.params.product as ProductType;
      this.handle = decodeURIComponent(
        this.$route.query.handle as string
      ).replace(/ /g, "+") as ProductLineName;
    }
  }
}
